import React from 'react';

import {
    InventoryListingPlaceholder,
} from 'reaxl-listing';

function InventoryCardPlaceHolder() {
    return (
        <>
            {Array.from({ length: 6 }, (_, index) => (
                <InventoryListingPlaceholder key={`inventory-placeholder-${index}`} />
            ))}
        </>
    );
}

export default InventoryCardPlaceHolder;
